
<script>
	// Initialize EmailJS with your user ID
	import emailjs from 'emailjs-com';
	emailjs.init('1waytQSNWVZuBRugE');
	import { onMount } from 'svelte';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	let fullName = '';
	let phoneNumber = '';
	let email = '';
	let date = '';
	let time = '';
	let children = 0;
	let adults = 0;
	let seniorCitizen = 0;
	let reservationCode = '';
	let total=0;
	let isEarlyBird;
	let isHappyHour;
	let policyChecked = false;
	let Submited = false;
	let outletinfo;

  	async function getinfo()
	{
		const resp = await fetch(`https://json.colmo.my/outlet?id=1&acc=aM737ZoQQxWwhgvAKxSDVCqbCJR2`)
			outletinfo = await resp.json();

		// console.log(outletinfo);
	}

	// let count = 0;
	// const password = "jomamigo3215";
	// let admin = false;
	// const handleadmin = () => {
	// 	count++;
	// 	if(count == 3)
	// 	{
	// 		count = 0;
	// 		let keyin = prompt("Admin Password");
	// 		if(keyin == password)
	// 		{
	// 			admin = true ;
	// 		}else if(keyin != password){
	// 			admin = false;
	// 		}
	// 	}
	// }

	// 	let close7pm = false;
	// 	let close8pm = false;
	// 	let close9pm = false;
	// 	let disabletoday = false;
	// 		function handleCheckboxChange(event) {
	// 		const { name, checked } = event.target;

	// 		if (name === 'close7pm') {
	// 		close7pm = checked;
	// 		} else if (name === 'close8pm') {
	// 		close8pm = checked;
	// 		} else if (name === 'close9pm') {
	// 		close9pm = checked;
	// 		}

	// 		if((close7pm && close8pm && close9pm) == true)
	// 		{
	// 			disabletoday= true;
	// 			console.log("disabletoday",disabletoday);
	// 		}

	// 		// console.log("close7pm",close7pm);
	// 		// console.log("close8pm",close8pm);
	// 		// console.log("close9pm",close9pm);
	// 	}

	// const handlechange = () =>{
		

	// }

	const handleSubmit = () => {
	  // Simple validation
	  if (!fullName || !phoneNumber || !email || !date || !time) {
		alert('Please fill in all fields.');
		return;
	  }
  
	  // Check if the number of children, adults, and senior citizens is not zero
	  if (children === 0 && adults === 0 && seniorCitizen === 0) {
		alert('Please specify the number of children, adults, or senior citizens.');
		return;
	  }
	  if(!policyChecked)
	  {
		alert('Please agree to the reservation policy.');
		return;
	  }
	
	  if((children + adults + seniorCitizen) < 2 )
	  {
		alert("Please note that we only accept reservations of 2 pax and above.");
		return;
	  }
  
	  // Log or process the reservation data
	//   console.log('Reservation Details 1:');
	//   console.log('ID:', generateID()); // Generating and logging ID
	//   console.log('Full Name:', fullName);
	//   console.log('Phone Number:', phoneNumber);
	//   console.log('Email:', email);
	//   console.log('Date:', date);
	//   console.log('Time:', time);
	//   console.log('Children:', children);
	//   console.log('Adults:', adults);
	//   console.log('Senior Citizen:', seniorCitizen);
	  signUp();
	  // Send auto-reply email
	  sendAutoReplyEmail(email);
  
	  // You can further process the data, send it to the server, etc.
	};
  
	const generateID = () => {
	  // Generate a random ID for the reservation
	  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	};

	function getexaclytoday(){
		const now = new Date();
	 return now.getDay();
	}

console.log(getexaclytoday());

	async function getToday() {
		await getinfo();
	  const now = new Date();
	  const year = now.getFullYear();
	  let month = now.getMonth() + 1;
	  let day;
	  

	  if (outletinfo && (outletinfo.disabletoday == true && outletinfo.disable7pm == true && outletinfo.disable8pm == true && outletinfo.disable9pm == true)) {
        day = now.getDate()+1;
		console.log("this is day +1",day);
    }
	else{
		day = now.getDate();
		console.log("this is day",day);
	}

	  if (month < 10) {
		month = `0${month}`;
	  }
	  if (day < 10) {
		day = `0${day}`;
	  }

	  if (outletinfo && (outletinfo.disabletoday == true && outletinfo.disable7pm == true && outletinfo.disable8pm == true && outletinfo.disable9pm == true)) {
        // If disabletoday is true, return tomorrow's date
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
		month = tomorrow.getMonth() + 1;
		day = tomorrow.getDate();
		
		if (month < 10) {
		month = `0${month}`;
	  }
		if (day < 10) {
		day = `0${day}`;
	  }

        return `${tomorrow.getFullYear()}-${month}-${day}`;
    } else {
        // Otherwise, return today's date
        return `${year}-${month}-${day}`;
    }
	}

	let min;
	getToday().then(today => {min = today; console.log("this is min",min);})
	

	let selecteddate = new Date();
	let dayOfWeek = selecteddate.getDay();
  
	$: {
	  // Update reservation code whenever fullName or phoneNumber changes
	  reservationCode = fullName.charAt(0).toUpperCase() + phoneNumber;
	//   console.log("this is date",getToday());
	//   console.log("this is selecteddate",selecteddate);
	//   console.log("this is dayofweek",dayOfWeek);
	//   console.log("this is time ",time);
	//   console.log("this is earlybird",isEarlyBird);
	//   console.log("this is happyhour",isHappyHour);
	}

	function handleDateChange(event) {
    selecteddate = new Date(event.target.value);
	dayOfWeek = selecteddate.getDay();

	console.log(selecteddate);
	const march11 = new Date(selecteddate.getFullYear(), 2, 11); // March is 2 (0-indexed)
	const nextWeek = new Date(march11.getTime() + 7 * 24 * 60 * 60 * 1000); // Adding 7 days
	isEarlyBird = new Date() >= march11 && new Date() <= nextWeek;
	calculateTotalCost();
	}
  
	onMount(async () => {
	  // Event listeners for input fields
	  document.getElementById('fullName').addEventListener('input', updateReservationCode);
	  document.getElementById('phoneNumber').addEventListener('input', updateReservationCode);
	  document.getElementById('email').addEventListener('input', () => {
		email = document.getElementById('email').value; // Update email variable on input change
		
	  });
	});
  
	function updateReservationCode() {
	  // Get values from input fields and update reservation code
	  const fullName = document.getElementById('fullName').value;
	  const phoneNumber = document.getElementById('phoneNumber').value;
	  reservationCode = fullName.charAt(0).toUpperCase() + phoneNumber;
	}
  
	const sendAutoReplyEmail = (recipientEmail) => {
	  const params = {
		email: recipientEmail, // Use recipientEmail as the email parameter
		message: reservationCode,
		to_name: fullName
	  };
  
	  emailjs.send('service_3s63byj', 'template_o637uww', params)
		.then(function(response) {
		  console.log('Email sent successfully!', response);
		  // Handle success, such as showing a success message to the user
		}, function(error) {
		  console.error('Error sending email:', error);
		  // Handle error, such as showing an error message to the user
		});
	};
	
	function calculateTotalCost() {
    let totalCost = 0;

	if((dayOfWeek != 0 && dayOfWeek != 6)&& time == "21:00" )
	{
		isHappyHour = true;
	}
	
	// let isEarlyBird = false;
	// let isHappyHour = false;

    
    // Regular pricing
    const regularPrice = {
        adult: 88.00,
        senior: 58.00,
        child: 38.00
    };
    
    // Early bird pricing
    const earlyBirdPrice = {
        adult: 79.90,
        senior: 49.90,
        child: 29.90
    };

	// Happy hour pricing
	const happyHourPrice = {
    adult: 29.90,
    senior: 19.90,
    child: 19.90 // Same as senior citizen for children during happy hour
};

if(isHappyHour) {
    totalCost += adults * happyHourPrice.adult;
    totalCost += (seniorCitizen + children) * happyHourPrice.senior; // Children priced as senior citizens during happy hour
}else if (isEarlyBird) {
    totalCost += adults * earlyBirdPrice.adult;
    totalCost += seniorCitizen * earlyBirdPrice.senior;
    totalCost += children * earlyBirdPrice.child;
}else {
    totalCost += adults * regularPrice.adult;
    totalCost += seniorCitizen * regularPrice.senior;
    totalCost += children * regularPrice.child;
}

total = totalCost.toFixed(2);
console.log(isHappyHour);
isHappyHour= false;

}

function handleBlur(event) {
    const value = event.target.value.trim(); // Trim any leading or trailing whitespace
    if (value === '') {
        event.target.value = '0'; // Set the value to '0' if it's empty
    }
}

function signUp(){
        var formdata = new FormData();
        	formdata.append("entry.353616244", fullName.toString());
            formdata.append("entry.600616754", phoneNumber.toString());
			formdata.append("entry.1028279962", date.toString()); // Replace "123456789" with the actual field ID for Company Name
       		formdata.append("entry.1722225485", time.toString()); // Replace "987654321" with the actual field ID for Remark
            formdata.append("entry.1378114536", email.toString());
		    formdata.append("entry.1036218907", reservationCode.toString().replaceAll('+',''));
            formdata.append("entry.1160866773", adults.toString());
			formdata.append("entry.2018888091", seniorCitizen.toString()); // Replace "123456789" with the actual field ID for Company Name
       		formdata.append("entry.249032152", children.toString()); // Replace "987654321" with the actual field ID for Remark
            formdata.append("entry.1750120170", total.toString());

		fetch(
            "https://docs.google.com/forms/d/e/1FAIpQLScRbxNTfPRCIn1OrOU2cR5jJYS0-f9Gn405PjUmjRAm4bBxiw/formResponse",
            { method: "POST", body: formdata, mode: "no-cors" }
        )
            .then((r) => r.text())
            .then((r) => {
				Submited = true;
            });
	}
  </script>
  

  <!-- <style>
	.admin{
		display : flex;
		flex: auto;
	}

	.admin input{
		width: auto;
		margin-bottom: 0px;
	}

	.admin div{
		padding:5%;
		display:flex;
	}

	.admin label{
		margin-left: 5px;
	}
  </style> -->
  
  <div class="image">
	<!-- <img on:click={handleadmin} src="logo.png" class="logo" alt="Colmo Cloud"> -->
	<img src="logo.png" class="logo" alt="Colmo Cloud">
</div>
  <div class="container">
	<!-- {#if admin == true}
	<div class="admin">
	<div>
		<input type="checkbox" id="close7pm" name="close7pm" bind:checked={close7pm} on:change={handleCheckboxChange}>
		<label for="close7pm">Close at 7pm</label>
	  </div>
	  
	  <div>
		<input type="checkbox" id="close8pm" name="close8pm" bind:checked={close8pm} on:change={handleCheckboxChange}>
		<label for="close8pm">Close at 8pm</label>
	  </div>
	  
	  <div>
		<input type="checkbox" id="close9pm" name="close9pm" bind:checked={close9pm} on:change={handleCheckboxChange}>
		<label for="close9pm">Close at 9pm</label>
	  </div>
	</div>
	<button on:click{handlechange}>
		save 
	</button>
	{:else} -->
	<h2>Make a Reservation</h2>
	<form on:submit|preventDefault={handleSubmit}>
	  <!-- Hidden input field for reservation ID -->
	  <input type="hidden" value={generateID()}>
  
	  <label for="fullName">Full Name</label>
	  <input bind:value={fullName} id="fullName" type="text" placeholder="Enter your full name">
  
	  <label for="phoneNumber">Phone Number</label>
	  <input bind:value={phoneNumber} id="phoneNumber" type="tel" placeholder="Enter your phone number">
	  <label for="email">Email Address</label>
	  <input type="text" bind:value={email} id="email" placeholder="Enter your email address">
  
	  {#if outletinfo && (outletinfo.disabletoday == true && outletinfo.disable7pm == true && outletinfo.disable8pm == true && outletinfo.disable9pm == true)}
	  <label for="date">Date (Today is full)</label>
	  {:else}
	  <label for="date">Date</label>
	  {/if}
	  <input bind:value={date} id="date" type="date" min={min} max="2024-04-09" on:change={handleDateChange}>  
	  
	  <label for="time">Time</label>
	  <select bind:value={time} id="time" on:change={calculateTotalCost}>
		{#if outletinfo && (outletinfo.disabletoday == true && outletinfo.disable7pm == true && selecteddate.getDay() == getexaclytoday())}
		<option value="19:00" disabled>7:00 PM (Full)</option>
		{:else}
		<option value="19:00">7:00 PM</option>
		{/if}
		{#if outletinfo && (outletinfo.disabletoday == true && outletinfo.disable8pm == true && selecteddate.getDay() == getexaclytoday())}
		<option value="20:00" disabled>8:00 PM (Full)</option>
		{:else}
		<option value="20:00">8:00 PM</option>
		{/if}
		{#if outletinfo && (outletinfo.disabletoday == true && outletinfo.disable9pm == true && selecteddate.getDay() == getexaclytoday())}
		<option value="21:00" disabled>9:00 PM (Full)</option>
		{:else}
		<option value="21:00">9:00 PM</option>
		{/if}
	  </select>
  
	  {#if date && time}
	  <div class="guests">
		<div>
		  <label for="children">Children</label>
		  <input bind:value={children} id="children" type="number" min="0" on:change={calculateTotalCost} on:blur={handleBlur} placeholder="0">
		</div>
		<div>
		  <label for="adults">Adults</label>
		  <input bind:value={adults} id="adults" type="number" min="0" on:change={calculateTotalCost}  on:blur={handleBlur} placeholder="0">
		</div>
		<div>
		  <label for="seniorCitizen">Senior Citizen</label>
		  <input bind:value={seniorCitizen} id="seniorCitizen" type="number" min="0" on:change={calculateTotalCost} on:blur={handleBlur} placeholder="0">
		</div>
	  </div>
	  {/if}

	  <label for="total">Total</label>
	  <input bind:value={total} type="text" id="total" readonly>
	  
	  <label for="reservationCode">Reservation Code</label>
	  <input bind:value={reservationCode} type="text" id="reservationCode" readonly>
  
	  <!-- Reservation Policy -->
	  <div class="policy">
		<p><strong>Reservation Policy (11 March - 9 April 2024)</strong></p>
		<ul>
		  <li>Jomamigo Steamboat Semi Buffet is available from 11 March - 9 April 2024 from 6:30PM-10.00PM at RM 88.00 nett per adult/ RM 58.00 nett per senior citizen aged 65 years old and above / RM 38.00 nett per child aged 5-11 years old.</li>
		  <li>A full prepayment is required upon reservation. Kindly take note that regular dining menu is not available during this period. Payment will be refunded fully if cancellation were made more than 72 hours prior to your reservation. Payment will be refunded 50% if cancellation were made between 48 - 72 hours prior to your reservation. Payment will be forfeited if cancellation were made within 48 hours prior to your reservation or no-show. Kindly be informed that the refund amount will be deducted 5% processing fees.</li>
		  <li>Visit our any Social Media to view Jomamigo buffet menu (@jomamigo)</li>
		</ul>
		<p><strong>Reservation Policy</strong></p>
		<ul>
			<li>Please note that we only accept reservations of 2 pax and above.</li>
			<li>Please note that we have a strict punctuality policy. Your table will be held for only 15 minutes from the time of your reservation and we cannot guarantee your reservation after this timing. Kindly note that we only seat complete parties (no waiting at the table).</li>
			<li>Please be informed that we only utilize open space concept. For a private room, you may request for it in the special request column of the booking form. Please be informed that it is subjected to availability.</li>
			<li>Kindly be informed that reservation is only accepted if the booking are made 1 hour or more prior to your reservation. For last minute reservation or any inquiries, kindly contact the outlet at +603-92130635 (available from 10:30AM - 8:00PM).</li>
		</ul>
		<p>-- Jomamigo Voucher can use for ala carte dishes only</p>
		<p>-- 10% off only for government staff, student and ioi staff</p>
		<p><strong>Price - Buffet steamboat Selera Melayu</strong></p>
			<ul>
			  <li>Rm88.00 Adult, Rm58.00 Senior citizen, Rm38.00 Child (nett incl tax)</li>
			  <li>Rm79.90 Adult, Rm49.90 Senior citizen, Rm29.90 Child (nett incl tax)</li>
		  		<p>-- Early bird only for first week of ramadhan</p>
		 	 <li>Rm29.90 Adult, Rm19.90 Senior citizen & Child</li>
		  		<p>-- Happy hours/Jom moreh (9pm Weekday sahaja)</p>
			</ul>
			<p><strong>Only buffet station , not include for steamboat (just for jom moreh)</strong></p>
	  </div>
	  <div class="policy-checkbox">
		<input type="checkbox" id="policyCheckbox" bind:checked={policyChecked}><label for="policyCheckbox">I agree to the reservation policy</label>
	</div>
	{#if Submited == false}
	  <button type="submit">Submit</button>	
	{/if}
	{#if Submited == true}
		<button disabled>Already Submited Reservation Thank You</button>
	{/if}
	</form>
	<!-- {/if} -->
  </div>
  